import React from 'react';
import { connect } from 'react-redux';
import { setDialogs, setMyIntegral } from '../../../actions';
import { getWelfareCenterParams } from '../../../rootStore';
import { $http, closeWebview } from '../../../lib/kbApp/kbJsBridgePromise';
import { hostv2 } from '../../../const';
import './index.scss';

class OfflineDialog extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      times: 8,
    };
    this.timer = null;
  }

	close = () => {
	  if (this.state.times > 0) {
	    return;
	  }
	  this.props.dialogs.pop();
	  this.props.dispatch(setDialogs(this.props.dialogs));
	}

	// 兑换现金
	// lock = false
	// exchange = async () => {
	//   if (this.lock) return;
	//   const { integral = 0, amount = 0 } = this.props.myIntegral;
	//   if (integral <= 0) return;
	//   this.lock = true;

	//   $http.get(`${hostv2}/ugwelfare/api/kbOfflineExchange`, {
	//     params: Object.assign(getWelfareCenterParams(), {
	//       scene: 'kb_v2',
	//     }),
	//   }).then((res) => {
	//     if (res.code === 0 && res.data) {
	//       const { exchangeIntegral = 0, getAmount = 0 } = res.data;
	//       this.props.dispatch(setMyIntegral({
	//         ...this.props.myIntegral,
	//         integral: integral - exchangeIntegral,
	//         amount: ((getAmount + (amount * 100)) / 100).toFixed(2),
	//       }));
	//     }
	//   })
	//     .finally(() => {
	//       this.lock = false;
	//     });
	// }

	componentDidMount() {
	  this.timer = setInterval(this.countDown, 1000);
	}

  countDown = () => {
    const { times } = this.state;

    if (times > 0) {
      this.setState({
        times: times - 1,
      });
    } else {
      clearInterval(this.timer);
    }
  }

  okAction = () => {
    if (this.state.times > 0) {
	    return;
	  }
    // 关闭弹窗自动给用户把当前的金币兑换成现金
    this.close();
    this.kbBack();
  }

  kbBack() {
    closeWebview();
  }

  render() {
    const { okText = '返回' } = this.props;
	  return (
			<div className="offlineDialog">
				<div className="dialog">
          {/* {from !== 'index' && <div className="close" onClick={this.close}></div>} */}
          <div className="title">福利中心下线通知</div>
          <div className="content">
            <div className="inner">
              <div>尊敬的用户，您好！</div>
              <br/>
              <p>由于业务调整，看点快报福利中心已于<span>2021年1月7日</span>下线。所有福利中心任务及服务均已全面停止。感谢大家对看点快报一直以来的支持。如有疑问，请前往个人中心反馈。</p>
              <br/>
              <div className="sign">看点快报产品团队</div>
            </div>
          </div>
          <div className={`btn ${this.state.times > 0 ? 'disable' : ''}`} onClick={this.okAction}>{okText}{this.state.times > 0 ? `(${this.state.times}秒)` : ''}</div>
				</div>
			</div>
	  );
  }
}

const mapStateToProps = (state) => {
  const { dialogs, myIntegral } = state;
  return {
    dialogs,
    myIntegral,
  };
};

export default connect(mapStateToProps)(OfflineDialog);
